import styled from 'styled-components';
import { getThemeBrand } from '@/shared/hooks/useBrandTheme';

const LOADER = getThemeBrand().assets.loader;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

export const Placeholder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: url(${LOADER?.default}) center / cover no-repeat;

  @media (max-width: 768px) {
    background-image: url(${LOADER?.mobile});
  }
`;

export const StyledImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  aspect-ratio: 3/4;
  object-fit: cover;
`;
